export default {
  users: [],
  pageable: {},
  user: null,
  userLicenseData: [],
  userPictureUrl: null,
}
